<template>
  <div>
    <PdkHeader />
    <div class="container-flight margin_container_hf">
      <!-- <flight-search class="search-box" /> -->
      <FlightChangeSearch :showChangeSearch="isShowChangeSearch" :searchItems="searchItems" />

      <PDKModal :buttonObject="modalButtonProps" v-if="showTimerModal" @btnAction="onTimeoutModalAction">
        <h3 slot="header">custom header</h3>
        <div style="text-align: center" slot="body">
          <img id="timer-logo" width="150" height="150" src="../../../public/img/out-of-ti.png" />
          <h4 style="margin-top: 10px">{{ $t("SearchResults.TimeOut") }}</h4>
        </div>
      </PDKModal>

      <div>
        <oneWay-selected-flight v-if="tripType == 1" @onChange="onChange" :selectedType="step"
          :selectedDeparture="selectedDeparture" />

        <twoWay-selected-flight v-if="tripType == 2" @onChange="onChange" :selectedType="step"
          :selectedDeparture="selectedDeparture" :selectedReturn="selectedReturn" />
        <div class="row">

          <aside class="filter-sidebar col-lg-3 col-md-4 col-sm-12">
            <div v-if="step == 1" class="card">
              <div class="card-body">
                <h5 class="card-title">
                  {{ $t("FlightFilter.TimeOut") }} <span v-if="tripType == 2">  {{ $t("FlightFilter.Departure") }} </span>
                </h5>
                <hr />
                <div class="filter_type group_mdi">
                  <a class="title-tools" data-toggle="collapse" href="#collapseFilters" aria-expanded="false"
                    aria-controls="collapseFilters" id="filters_col_bt">

                    <i class="icon-back-in-time filter-icon"></i>
                  </a>
                  <Range v-if="temp != null" :values="TimesArray" type="double" @onFinish="filterByDepartureTime" />
                  <Range :values="TimesArray" type="double" v-else />
                  <span class="highlight"></span><span class="bar"></span>
                  <label for="">{{ $t("FlightFilter.FlightTime") }}</label>
                </div>

                <div class="card-text mb-4"></div>
                <hr />
                <div class="filter_type">
                  <a class="title-tools" data-toggle="collapse" href="#collapseFilters" aria-expanded="false"
                    aria-controls="collapseFilters" id="filters_col_bt">
                    <i class="icon icon-plane filter-icon"></i> {{ $t("FlightFilter.AirLines") }}
                  </a>
                  <PdkAirlineFilter v-if="temp != null" :airlines="departureAirlines" />
                  <PdkAirlineFilter v-else />
                </div>
                <div class="filter_type">
                  <hr />
                  <a class="title-tools" data-toggle="collapse" href="#collapseFilters" aria-expanded="false"
                    aria-controls="collapseFilters" id="filters_col_bt">
                    <i class="icon icon-ticket-2 filter-icon"></i> {{ $t("FlightFilter.TicketType") }}
                  </a>

                  <ul>
                    <li>
                      <pdk-ckeckbox class="checkBox" type="checkbox" name="airline" value="12" title='$t("FlightFilter.Economic")' />
                    </li>
                    <li>
                      <pdk-ckeckbox class="checkBox" type="checkbox" name="airline" value="12" title='$t("FlightFilter.Business")' />
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div v-if="step == 2" class="card">
              <div class="card-body">
                <h5 class="card-title">{{ $t("FlightFilter.DepartureFlightFilter") }}</h5>
                <hr />
                <div class="filter_type">
                  <a class="title-tools" data-toggle="collapse" href="#collapseFilters" aria-expanded="false"
                    aria-controls="collapseFilters" id="filters_col_bt">
                    <i class="icon-back-in-time filter-icon"></i>
                  </a>
                  <Range v-if="temp != null" :values="TimesArray" type="double" @onFinish="filterByReturnTime" />
                  <Range v-else :values="TimesArray" type="double" />
                  <label for=""> {{ $t("FlightFilter.FlightTime") }}</label>
                  <span class="highlight"></span><span class="bar"></span>
                </div>

                <div class="card-text mb-4"></div>
                <hr />
                <div class="filter_type">
                  <a class="title-tools" data-toggle="collapse" href="#collapseFilters" aria-expanded="false"
                    aria-controls="collapseFilters" id="filters_col_bt">
                    <i class="icon icon-plane filter-icon"></i> {{ $t("FlightFilter.AirLines") }}
                  </a>
                  <PdkAirlineFilter v-if="temp != null" :airlines="returnAirlines" />
                  <PdkAirlineFilter v-else />
                </div>
                <div class="filter_type">
                  <hr />
                  <a class="title-tools" data-toggle="collapse" href="#collapseFilters" aria-expanded="false"
                    aria-controls="collapseFilters" id="filters_col_bt">
                    <i class="icon icon-ticket-2 filter-icon"></i> {{ $t("FlightFilter.AirLines") }}
                  </a>

                  <ul>
                    <li>
                      <pdk-ckeckbox class="checkBox" type="checkbox" name="airline" value="12" title="اکونومی" />
                    </li>
                    <li>
                      <pdk-ckeckbox class="checkBox" type="checkbox" name="airline" value="12" title="بیزینس" />
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="box_style_2">
              <i class="icon_set_1_icon-57"></i>
              <h4>
                به کمک
                <span>نیاز دارید؟</span>
              </h4>
              <a style="direction: ltr" href="tel://021446313605" class="phone">021-44631360-5</a>
              <a style="direction: ltr" href="tel://021446313605" class="phone">09045425792</a>
            </div>
          </aside>
          <div v-if="showNotFoundFlight" class="avail-container col-lg-9 col-md-8 col-sm-12">
            <FlightNotFound v-if="showNotFoundFlight" @notFoundAction="onFlightNotFoundAction"
              :withoutChangeDate="true" />
          </div>
          <div v-if="!showNotFoundFlight" class="avail-container col-lg-9 col-md-8 col-sm-12">
            <div>
              <div class="card p-4" v-if="step < 3">
                <div class="flight_title">
                  <h2>
                    انتخاب پرواز
                    <span v-if="step === 1 && tripType == 2">رفت</span>
                    <span v-if="step === 2 && tripType == 2">برگشت</span>
                  </h2>
                </div>

                <SklAvailCard v-if="isLoadingFlight" />
                <div v-else>
                  <div v-if="step == 1 && departureList.length">
                    <PdkFlightSort @sortBy="sortDepartureFlightBy"></PdkFlightSort>

                    <pdk-flight-grid :flightList="departureList" @selected="onDepurtureSelect" />
                  </div>
                </div>
                <div v-if="step == 2">
                  <PdkFlightSort @sortBy="sortReturnFlightBy"></PdkFlightSort>
                  <pdk-flight-grid :flightList="returnList" @selected="onReturnSelect" />
                </div>
                <div v-if="step == 2 && this.selected.returnFlights === null">
                  پرواز برگشت یافت نشد
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PdkFooter />
  </div>
</template>

<script>
import moment from "moment";
import PdkHeader from "@/components/PdkHeader";
import flightTime from "@/components/shared/FlightTime";
import flightsComponent from "@/components/tour/FlightSelect";
import Range from "@/components/PdkRange";
import PdkFlightSort from "@/components/flight/FlightSort";
import PdkAirlineFilter from "@/components/shared/AirlineFilter";
import CheckBox from "@/components/PdkCheckBox";
import dateUtil from "../../utils/date";
import store from "../../views/flight/store/index";
import SklAvailCard from "@/components/shared/Skeletons/SKLAvailCard";
import FlightNotFound from "@/components/flight/FlightNotFound";
import PDKModal from "@/components/PDKAlertModal";
import TwoWaySelectedFlight from "./TwoWaySelectedFlight";
import OneWaySelectedFlight from "./OneWaySelectedFlight";
import PdkFlightGrid from "./PdkFlightGrid";
import FlightSearch from "./FlightSearch.vue";
import FlightChangeSearch from "@/components/flight/FlightChangeSearch";
import PdkFooter from "@/components/PdkFooter";


export default {
  store,
  name: "FlightSearch",
  components: {
    "flight-time": flightTime,
    "flight-select": flightsComponent,
    "pdk-ckeckbox": CheckBox,
    PDKModal,
    SklAvailCard,
    Range,
    PdkFlightSort,
    PdkAirlineFilter,
    FlightNotFound,
    TwoWaySelectedFlight,
    OneWaySelectedFlight,
    PdkFlightGrid,
    FlightSearch,
    FlightChangeSearch,
    PdkHeader,
    PdkFooter
  },

  data() {
    return {
      modalButtonProps: {
        title: "جستجوی مجدد",
      },
      isDisableButton: false,
      isShowPrice: true,
      showTimerModal: false,
      timer: "",
      isShowChangeSearch: false,
      step: 1,
      selected: { departureFlight: null, returnFlight: null },
      items: { departureFlights: [], returnFlights: [] },
      temp: {},
      departureAirlines: [],
      returnAirlines: [],
      searchItems: {},
      params: {},
      isLoadingFlight: true,

      showNotFoundFlight: false,
      showNotFoundRoom: false,
      departureList: [],
      returnList: [],
      tripType: 1,
    };
  },

  created() {
    this.params = this.$route.query;

    this.tripType = this.params.tripType;

    if (this.tripType == 1) this.getOneWayFlight();
    else if (this.tripType == 2) this.getTwoWayFlight();

    this.clearStores();

    this.timer = setTimeout(() => {
      this.searchTimeout();
    }, 600000);
  },

  methods: {
    clearStores() {
      this.$store.commit("SetOneWayFlightSelected", "");
      this.$store.commit("SetTwoWayFlightSelected", "");
    },

    onTimeoutModalAction() {
      window.location.reload();
    },
    searchTimeout() {
      this.showTimerModal = true;
    },

    onFlightNotFoundAction(event) {
      this.$router.push({
        path: "/",
      });
    },
    onChange(val) {
      this.step = val;
    },

    async sortDepartureFlightBy(sort) {
      if (this.sortType === sort) {
        this.ascending = !this.ascending;
      } else {
        this.ascending = true;
        this.sortType = sort;
      }
      var ascending = this.ascending;

      this.temp.departureFlights.sort(function (a, b) {
        if (a[sort] > b[sort]) {
          return ascending ? 1 : -1;
        } else if (a[sort] < b[sort]) {
          return ascending ? -1 : 1;
        }
        return 0;
      });
    },
    async sortReturnFlightBy(sort) {
      if (this.sortType === sort) {
        this.ascending = !this.ascending;
      } else {
        this.ascending = true;
        this.sortType = sort;
      }
      var ascending = this.ascending;

      this.temp.returnFlights.sort(function (a, b) {
        if (a[sort] > b[sort]) {
          return ascending ? 1 : -1;
        } else if (a[sort] < b[sort]) {
          return ascending ? -1 : 1;
        }
        return 0;
      });
    },
    async getOneWayFlight() {
      var fromDate = dateUtil.ConvertToPersian(this.params.fromDate);

      const request = {
        origin: this.params.origin,
        destination: this.params.destination,
        departureDateTime: fromDate,
        adultQty: this.params.adultQty,
        infantQty: this.params.infantQty,
        childQty: this.params.childQty,
        sourceId: localStorage.getItem("SourceIdInReport"),
      };

      this.departureList = await this.$store.dispatch(
        "getOneWayAvailableFlights",
        request
      );

      const departureLength = this.departureList.length;

      this.isLoadingFlight = false;
      if (departureLength > 0) {
        this.departureAirlines = this.departureList.groupBy(
          (t) => t.airLineName
        );
      }
    },

    async getTwoWayFlight() {
      var fromDate = dateUtil.ConvertToPersian(this.params.fromDate);
      var toDate = dateUtil.ConvertToPersian(this.params.toDate);

      const request = {
        origin: this.params.origin,
        destination: this.params.destination,
        departureDate: fromDate,
        returnDate: toDate,
        adultQty: this.params.adultQty,
        infantQty: this.params.infantQty,
        childQty: this.params.childQty,
        sourceId: localStorage.getItem("SourceIdInReport"),
      };

      this.items = await this.$store.dispatch(
        "getTwoWayAvailableFlights",
        request
      );
      const departureLength = this.items.departureFlights.length;
      const returnLength = this.items.returnFlights.length;

      this.isLoadingFlight = false;
      if (departureLength > 0 && returnLength > 0) {
        this.temp = JSON.parse(JSON.stringify(this.items));

        this.departureList = this.temp.departureFlights;
        this.returnList = this.temp.returnFlights;

        this.departureAirlines = this.temp.departureFlights.groupBy(
          (t) => t.airLineName
        );
        this.returnAirlines = this.temp.returnFlights.groupBy(
          (t) => t.airLineName
        );
      }
    },

    filterByDepartureTime(value) {
      const date = moment(this.$route.query.fromDate).format("YYYY/MM/DD");
      const from = moment(`${date} ${value.fromValue}`, "YYYY/MM/DD HH:mm");
      const to = moment(`${date} ${value.toValue}`, "YYYY/MM/DD HH:mm");
      this.departureList = JSON.parse(
        JSON.stringify(this.items.departureFlights)
      );
      this.departureList = this.departureList.where(
        (t) =>
          moment(t.departureDateTime, "YYYY/MM/DD HH:mm").isSameOrBefore(to) &&
          moment(t.departureDateTime, "YYYY/MM/DD HH:mm").isSameOrAfter(from)
      );
    },
    filterByReturnTime(value) {
      const date = moment(this.$route.query.toDate).format("YYYY/MM/DD");
      const from = moment(`${date} ${value.fromValue}`, "YYYY/MM/DD HH:mm");
      const to = moment(`${date} ${value.toValue}`, "YYYY/MM/DD HH:mm");
      this.returnList = JSON.parse(JSON.stringify(this.items.returnFlights));
      this.returnList = this.returnList.where(
        (t) =>
          moment(t.departureDateTime, "YYYY/MM/DD HH:mm").isSameOrBefore(to) &&
          moment(t.departureDateTime, "YYYY/MM/DD HH:mm").isSameOrAfter(from)
      );
    },
    onDepurtureSelect(item) {
      if (this.tripType == 2) this.step = 2;
      this.selected.departureFlight = item;
    },
    onReturnSelect(item) {
      this.selected.returnFlight = item;
    },
    onDepartureEdit() {
      this.step = 1;
    },
    onReturnEdit() {
      this.step = 2;
    },
  },
  computed: {
    TimesArray() {
      let arr = [];
      for (let i = 0; i <= 22; i++) {
        const d = new Date();
        d.setHours(i, 0, 0, 0);
        arr.push(d.toTimeString().substring(0, 5));
      }
      arr.push("23:59");
      return arr;
    },
    selectedDeparture() {
      return this.selected.departureFlight;
    },
    selectedReturn() {
      return this.selected.returnFlight;
    },
  },
};
</script>

<!-- <style scoped>
.flight_title {
  text-align: center;
  font-size: 16px;
  margin-bottom: 10px;
}
.flight_title h2 {
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: -1px;
  font-size: 19px;
  margin-bottom: 0;
  margin-top: 0;
}
.flight_title h2 span {
  color: #00c3e1;
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.search-box {
  position: relative;
  z-index: 9999;
  padding-bottom: 40px;
}

@media only screen and (max-width: 750px) {
.avail-container {
  flex: 0 0 100% !important;
   max-width: 100% !important;
}
.filter-sidebar {
   display: none !important;
  
}
}

.filter-sidebar {
  flex: 0 0 27%;
 max-width: 27%;
}

.avail-container {
flex: 0 0 73%; max-width: 73%;
}
</style> -->
<style scoped>
.bar label {
  margin-top: -38px;
}

@media only screen and (max-width: 750px) {
  .avail-container {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }

  .filter-sidebar {
    display: none !important;
  }
}

.margin_container_hf {
  margin-top: 125px;
  padding: 20px 70px;
}

.filter-sidebar {
  flex: 0 0 27%;
  max-width: 27%;
}

.avail-container {
  flex: 0 0 73%;
  max-width: 73%;
}

.flight_title {
  text-align: center;
  font-size: 16px;
  margin-bottom: 10px;
}

.flight_title h2 {
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: -1px;
  font-size: 19px;
  margin-bottom: 0;
  margin-top: 0;
}

.flight_title h2 span {
  color: #00c3e1;
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}

.component-fade-enter,
.component-fade-leave-to

/* .component-fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>